<mat-form-field appearance="outline">
  <mat-label>{{ field.key | translate }}</mat-label>
  <input matInput
         #timePicker
         id="timePicker"
         type="text"
         pattern="([0-1]{1}[0-9]{1}|20|21|22|23):[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}"
         step="1"
         (input)="onValueChange()"
         [formControl]="field.control"
         [transform]="toDbModel.bind(this)"
         placeholder="{{ field.key | translate }}" />
</mat-form-field>
